// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.11.0",
  date: "2026-10-06T11:51:44.895Z",
  gitInfo: {
    dirty: false,
    raw: "28fa67996",
    hash: "28fa67996",
    distance: null,
    tag: null,
    semver: null,
    suffix: "28fa67996",
    semverString: null
  }
};
/* tslint:enable */
